import React from "react";
import { Link } from "react-router-dom";

const SignIn = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 font-sans">
      {/* Logos */}
      <div className="flex gap-4 mb-8">
      <h>PΛREΛGON</h>
      </div>

      {/* Form Section */}
      <div className="max-w-md w-full">
        <h1 className="text-2xl font-semibold mb-4">
          Enter your email to join us or sign in.
        </h1>

        <p className="text-sm mb-4 text-gray-700">
          United States <span className="text-black underline cursor-pointer ml-2">Change</span>
        </p>

        <input
          type="email"
          placeholder="Email*"
          className="w-full border border-gray-400 px-4 py-3 rounded-md mb-6 focus:outline-none focus:ring-1 focus:ring-black"
        />

        <p className="text-xs text-gray-500 mb-6">
          By continuing, I agree to PΛREΛGON{" "}
          <Link to="/privacy" className="underline">Privacy Policy</Link> and{" "}
          <Link to="/terms" className="underline">Terms of Use</Link>.
        </p>

        <button className="bg-black text-white px-6 py-3 rounded-full w-full font-medium hover:bg-gray-800 transition">
          Continue
        </button>
      </div>
    </div>
  );
};

export default SignIn;
